import React from 'react'
import styles from './sidebar.module.scss'
import logolight from '../../../../assets/logo-light.svg'
function BrandLogo() {
    return (
        <div className={styles.logo_container}>
            <img src={logolight} />
        </div>
    )
}

export default BrandLogo